import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = {
  style: {"padding":"0px 20px"},
  "element-loading-text": "正在提交数据，请稍后"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode("部门信息")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("角色权限")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("关闭")

import { ref, onMounted, reactive, unref } from 'vue';
import { ElForm, FormRules, ElMessage } from 'element-plus';
import { GbDialog } from '@/components/GbDialog/Index';
import { useDictionary } from '@/store/dictionary.store';
import { GetuserInfoApi, CreateuserApi, EditoruserApi,ErpUserAsyncApi, GetErpUserInfoApi } from '@/apis/basics/users/apis';
import { GetDeptCascaderTreeApi } from '@/apis/basics/department/apis';
import { RoleDowndownListApi } from '@/apis/basics/roles/api';
import { GetCompanyDpListApi } from '@/apis/basics/companys/apis';

// emits

export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { getSelectList } = useDictionary();
const formRef = ref<ComponentRef<typeof ElForm>>();

const formSchema = ref<any>({});

/* 表单验证规则 */
const roleList = ref<any[]>([]);

const formRulesSave: FormRules = {
	user_code: [{ required: true, message: '用户编号不能留空', trigger: 'blur' }],
	user_name: [{ required: true, message: '用户姓名不能留空', trigger: 'blur' }],
	status: [{ required: true, message: '在职状态未选', trigger: 'blur' }],
	joined_date: [{ required: true, message: '入职日期未选', trigger: 'blur' }],
	roles: [{ required: true, message: '请选择用户角色', trigger: 'blur' }],
	user_type: [{ required: true, message: '请选择用户类型', trigger: 'blur' }],
};


const formRulesAsync: FormRules = {
	user_code: [{ required: true, message: '用户编号不能留空', trigger: 'blur' }]
};

const state = reactive({
	show: false,
	loading: false,
	canCreate: false, /*只有同步到ERP的数据才能创建用户*/
	deptList: [],
	save: false, /*用来控制表单验证规则，同步时只验证用户编号，保存时需要验证其他数据*/
	companyList: [] as any[],
	cascaderProps: {
		// expandTrigger: 'hover',
		checkStrictly: true,
		emitPath: false,
		label: 'dept_name',
		value: 'id',
	},
});

const load = {
	/* 部门联级选择 */
	getDeptCascaderTree: async (cmpId: string) => {
		const { succeeded, errors, data } = await GetDeptCascaderTreeApi(cmpId);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			state.deptList = data || [];
		}
	},

	/* 角色选择列表 */
	getRoleList: async () => {
		const { succeeded, data } = await RoleDowndownListApi();
		roleList.value = !succeeded ? [] : data || [];
	},

	/* 可登录数据范围 */
	getCompanyList: async () => {
		const { succeeded, data } = await GetCompanyDpListApi();
		state.companyList = !succeeded ? [] : data || [];
	},
};
/* ERP数据同步 */
const asyncERPUserInfo = () =>{
	state.save = false
	unref(formRef)?.validate(async (isValid: boolean) => {
		if (!isValid) return;

		state.loading = true;
		const dataIn = unref(formSchema);
		const dataUserCode: Object ={user_code:dataIn.user_code}
		const { succeeded, errors , data } = await GetErpUserInfoApi(dataUserCode);
		if (!succeeded) {
			state.canCreate = false
			ElMessage.error(errors);
		} else {
			ElMessage.success('同步成功');
			data.sex = data.sex + '';
			data.status = data.status + '';
			formSchema.value=Object.assign(data);
			state.canCreate = true;
			state.save = true;

		}
		state.loading = false;
	});

}





/* 保存数据 */
const onSaveBtnClick = () => {
	state.save = true;
	unref(formRef)?.validate(async (isValid: boolean) => {
		if (!isValid) return;

		state.loading = true;
		const data = unref(formSchema);
		const apis = CreateuserApi;

		const { succeeded, errors } = await apis(data);
		if (!succeeded) {
			ElMessage.error(errors);
		} else {
			ElMessage.success('保存成功');
			state.show = false;
		}

		state.loading = false;
		$emits('refresh');
	});
};

const exposeFunc = {
	create: () => {
		formSchema.value = {};
		state.loading = false;
		state.show = true;
	},

};

expose({ ...exposeFunc });

onMounted(() => {
	load.getDeptCascaderTree(''); // 应该获取当前用户所属公司下的部门
	load.getRoleList();
	load.getCompanyList();
});

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_divider = _resolveComponent("el-divider")!
  const _component_el_cascader = _resolveComponent("el-cascader")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: _unref(state).show,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(state).show) = $event)),
    title: `注册用户`,
    style: {"width":"720px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        class: "w90",
        type: "primary",
        disabled: _unref(state).loading || !_unref(state).canCreate,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _hoisted_4
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        class: "w90",
        type: "info",
        disabled: _unref(state).loading,
        onClick: _cache[11] || (_cache[11] = ($event: any) => (_unref(state).show = false))
      }, {
        default: _withCtx(() => [
          _hoisted_5
        ]),
        _: 1
      }, 8, ["disabled"])
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "formRef",
          ref: formRef,
          "label-width": "80px",
          model: formSchema.value,
          "label-position": 'right',
          rules: _unref(state).save ? formRulesSave : formRulesAsync
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用户编号",
                      prop: "user_code"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.user_code,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.user_code) = $event)),
                          placeholder: "用户编号",
                          onBlur: asyncERPUserInfo
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "用户姓名",
                      prop: "user_name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.user_name,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.user_name) = $event)),
                          disabled: true,
                          type: "text",
                          placeholder: "用户姓名"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "性别" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.sex,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.sex) = $event)),
                          style: {"width":"100%"}
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('sex'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: `${item.value}`
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "联系电话" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.mobile,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.mobile) = $event)),
                          type: "text",
                          placeholder: "联系电话"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          type: "textarea",
                          "show-word-limit": "",
                          maxlength: "50",
                          modelValue: formSchema.value.remark,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.remark) = $event)),
                          rows: "4",
                          placeholder: "备注"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, {
                  "border-style": "dashed",
                  "content-position": "center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "部门" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_cascader, {
                          modelValue: formSchema.value.dept_id,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.dept_id) = $event)),
                          props: _unref(state).cascaderProps,
                          options: _unref(state).deptList,
                          clearable: "",
                          filterable: "",
                          style: {"width":"100%"},
                          placeholder: "所属部门"
                        }, null, 8, ["modelValue", "props", "options"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: "当前状态",
                      prop: "status"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.status,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formSchema.value.status) = $event)),
                          style: {"width":"100%"},
                          disabled: "true"
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getSelectList)('user_status'), (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.label,
                                value: `${item.value}`
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "入职日期" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_date_picker, {
                          modelValue: formSchema.value.joined_date,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formSchema.value.joined_date) = $event)),
                          style: {"width":"100%"},
                          type: "date",
                          placeholder: "入职日期",
                          format: "YYYY-MM-DD",
                          "value-format": "YYYY-MM-DD"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_divider, {
                  "border-style": "dashed",
                  "content-position": "center"
                }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_el_form_item, {
                      label: "用户角色",
                      prop: "roles"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_select, {
                          modelValue: formSchema.value.roles,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formSchema.value.roles) = $event)),
                          class: "w100p",
                          filterable: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(roleList.value, (role) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: role.name,
                                value: role.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"]), [
                          [_vShow, false]
                        ])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, false]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 12 }, {
                  default: _withCtx(() => [
                    _withDirectives(_createVNode(_component_el_form_item, {
                      label: "账户类型",
                      prop: "user_type"
                    }, {
                      default: _withCtx(() => [
                        _withDirectives(_createVNode(_component_el_select, {
                          modelValue: formSchema.value.user_type,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formSchema.value.user_type) = $event)),
                          disabled: true,
                          class: "w100p"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_option, {
                              label: "普通用户",
                              value: 0
                            }),
                            _createVNode(_component_el_option, {
                              label: "虚拟用户",
                              value: 1
                            }),
                            _createVNode(_component_el_option, {
                              label: "其他",
                              value: 99
                            }),
                            _createVNode(_component_el_option, {
                              label: "管理员",
                              value: 999
                            }),
                            _createVNode(_component_el_option, {
                              label: "超级管理员",
                              value: 1000
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"]), [
                          [_vShow, false]
                        ])
                      ]),
                      _: 1
                    }, 512), [
                      [_vShow, false]
                    ])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, { label: "关联公司" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_select, {
                          modelValue: formSchema.value.companys,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formSchema.value.companys) = $event)),
                          class: "w100p",
                          filterable: "",
                          "collapse-tags": "",
                          "collapse-tags-tooltip": "",
                          multiple: ""
                        }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).companyList, (cp) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: cp.name,
                                value: cp.value
                              }, null, 8, ["label", "value"]))
                            }), 256))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model", "rules"])
      ])), [
        [_directive_loading, _unref(state).loading]
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})